import { render } from "./TranslationsFooter.vue?vue&type=template&id=1233f384&scoped=true"
import script from "./TranslationsFooter.vue?vue&type=script&lang=js"
export * from "./TranslationsFooter.vue?vue&type=script&lang=js"

import "./TranslationsFooter.vue?vue&type=style&index=0&id=1233f384&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\craft-cms-3-plugins\\craft3-translate\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1233f384"]])

export default __exports__